import { environment } from './../../environments/environment';
import { Injectable } from '@angular/core';
import { io } from "socket.io-client";
import { Observable } from 'rxjs';
import { Notification } from 'app/models2/notification/notification';
import { LocalStorageService } from 'brainloper-ui';
import { INotificationByCompany } from 'app/models2/maintenance/notification-by-company';

@Injectable({
  providedIn: 'root'
})
export class SocketWebService {
  socket: any
  companyId: number = this.storage.get('companyId')
  constructor(
    private storage : LocalStorageService,
  )  
  {
    const socketPath = environment.path ? `/${environment.path}/socket.io` : '/socket.io';
    
    const endpointBase = environment.path 
      ? environment.endpoint.replace(`/${environment.path}`, '')
      : environment.endpoint;
    
    this.socket = io(endpointBase, {
      path: socketPath
    });
  }

  public listen(eventName: string) {
    return new Observable((subscribe) => {
      this.socket.on(eventName, (data: any) => {
        subscribe.next(data);
      })
    })
  }

  public emit(eventName: string, data: any) {
    this.socket.emit(eventName, data)
  }

  public updateNotificationEmit(notification: Notification) {
    if (notification.notified && notification.notified as number > 0){
      let notified = notification.notified.toString()
      if (this.companyId === null){
        this.companyId = this.storage.get('companyId')        
      }
      let companyId = this.companyId.toString()
      let notificationData: INotificationByCompany = {userId: notified, companyId}
      this.emit('update-notification', notificationData)
  }
    if (notification.roleId && notification.roleId > 0){
      let roleId = notification.roleId.toString()      
      let companyId = this.companyId.toString()
      let notificationData: INotificationByCompany = {roleId, companyId}
      this.emit('update-notification-by-rol', notificationData)
    }
  }

  public updateNotificationsEmit(notifications: Array<Notification>) {
    for (let notification of notifications) {
      this.updateNotificationEmit(notification)
    }
  }
}
